import { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useUser } from "../../Components/UserContext";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import CountdownTimer from "../../Components/CountdownTimer";
import { useDispatch, useSelector } from "react-redux";
import { addUserToken } from "../../redux/slices/userTokenSlice";
import UserLogo from "../../Assets/Images/LogoUser.png"
import topBanaer from "../../Assets/Images/user_login_screen_top.png"

const CodeVerification = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const authUser = useSelector((state) => state?.userAuth?.user);
    const vendorUrl = localStorage.getItem("vendorUrl");
    const [isLoading, setLoadingStatus] = useState(false);
    const [otp, setOTP] = useState([]);
    const location = useLocation();
    const [modalOpen, setModalOpen] = useState(false);
    const [userEmail, setuserEmail] = useState()
    const { appUser, setUser } = useUser();
    const [btnloadingStatus, setBtnLoadingStatus] = useState()
    const [showResendOTP, setShowResendOTP] = useState(false);
    const [triggerTimer, setTriggerTimer] = useState(false);
    // useEffect(() => {
    //     if (!location.state.mobileNumber && location.state.mobileNumber == '') {
    //         navigate('/login')
    //     }
    //     let check = localStorage.getItem("login");
    //     // let productCart = localStorage.getItem("productCart");
    //     // && productCart.cartId
    //     if (check == "logged") {
    //         navigate(-3);
    //     }  
    //     //  else {
    //     //     navigate('/')
    //     // }


    // }, [value]);

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        if (otp.length != 4) {
            toast("Please enter a valid 4-digit OTP", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                theme: "light",
                className: "text-danger toast-style-1"
            });
            return;
        }

        // if (!appUser && !location?.state?.email) {
        //     showToast("User data missing");
        //     return;
        // }

        setLoadingStatus(true);

        try {
            // appUser can be missing entirely when the signup is being resumed on
            // another device, so fall back to the address this screen was opened
            // with.
            const verifyEmail = userEmail || appUser?.user_email || location?.state?.email;

            const verifyBody = {
                email: verifyEmail,
                otp: otp.join("")
            };

            const verifyRes = await NodeaxiosInstance.post("auth/verify-email-otp", verifyBody);

            if (verifyRes?.status != 200) {
                throw new Error("Email OTP verification failed");
            }

            // Verifying the email was the only thing outstanding: the account is
            // already registered and the user already authenticated.
            if (location?.state?.flow == "loginEmailVerify") {
                localStorage.setItem("login", 'logged');
                navigate(vendorUrl ? vendorUrl : '/', { replace: true });
                return;
            }

            if (location?.state?.flow == "emailverify") {
                navigate('/change-password', { state: { inputType: 1, inputValue: verifyEmail, flow: 'emailverify' } })
                return;
            }

            // The server already holds the profile from signup; anything still in
            // appUser is only a fallback for a session started before this change.
            const registerRes = await NodeaxiosInstance.post("auth/register-user", appUser || {});

            if (registerRes?.status == 200) {
                // Only now is the account actually active. Marking it logged in
                // any earlier stranded users on a half-registered account.
                dispatch(addUserToken({ ...(authUser || {}), user_reg_status: 1 }));
                localStorage.setItem("login", 'Register');
                localStorage.removeItem("appUser");
                navigate(vendorUrl ? vendorUrl : "/registration-success");
            } else {
                throw new Error("Registration failed");
            }

        } catch (error) {
            console.error(error);

            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong";

            showToast(message);

        } finally {
            setLoadingStatus(false);
        }
    };


    const inputsRef = useRef([]);
    const numInputs = 4;


    const handleChange = (val, index) => {
        const numeric = val.replace(/\D/g, "");
        if (!numeric) return;

        const newOtp = [...otp];
        newOtp[index] = numeric;
        setOTP(newOtp);
        if (index < numInputs - 1) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            e.preventDefault();
            const newOtp = [...otp];

            if (newOtp[index]) {
                newOtp[index] = "";
                setOTP(newOtp);
            } else if (index > 0) {
                newOtp[index - 1] = "";
                setOTP(newOtp);
                inputsRef.current[index - 1]?.focus();
            }
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
        if (!pasted) return;

        const newOtp = [...otp];
        pasted.split("").forEach((char, i) => {
            if (i < numInputs) {
                newOtp[i] = char;
            }
        });
        setOTP(newOtp);

        const lastIndex = Math.min(pasted.length, numInputs) - 1;
        inputsRef.current[lastIndex]?.focus();
    };

    const handelEditUserMobileNum = async () => {
        try {
            setBtnLoadingStatus(true);
            const reqData = { email: userEmail };

            const response = await NodeaxiosInstance.post("auth/send-email-otp", reqData);
            if (response?.data?.status == 1) {
                const updatedUser = { ...appUser, user_email: userEmail };
                setUser(updatedUser);
                showToast(response?.data?.message || "OTP sent successfully", 'success');
                setModalOpen(false);
            }
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Something went wrong";
            showToast(message, {
                position: "bottom-center", autoClose: 3000,
                hideProgressBar: true, theme: "light", className: "text-danger toast-style-1"
            });
        } finally {
            setBtnLoadingStatus(false);
        }
    };

    const resendOTP = async (type) => {
        const reqData = { email: userEmail || appUser?.user_email || location?.state?.email };
        const response = await NodeaxiosInstance.post("auth/send-email-otp", reqData);
        if (response?.data?.status == 1) {
            showToast(response?.data?.message || "OTP sent successfully", {
                position: "bottom-center", autoClose: 3000,
                hideProgressBar: true, theme: "light",
            });
            setModalOpen(false);
            setTriggerTimer(triggerTimer => !triggerTimer);
            setShowResendOTP(false)
        }
    }

    return (
        <>  <div className=" bg-white ">
            <div className="position-relative">
                <img src={topBanaer} height="110px" width="100%" />
                <img src={UserLogo} height="80px" width="80px" className="rounded-3 position-absolute top-100 start-50 translate-middle  mb-2 " />
            </div>
            <div className="loginPage p-0 vh-100 bg-white d-flex align-items-center">
                <div className="px-4">
                    <div className="ff-poppins-bold fs-24 secondary-text">Verification Code</div>
                    <div className="ff-poppins-light fs-14 secondary-text">We have sent the verification code to the email {userEmail ?? location?.state?.email ?? "your email"}
                        <span className="primary-text ff-poppins-medium  ms-1" onClick={() => { setModalOpen(true); setuserEmail(userEmail ? userEmail : location?.state?.email) }}>(Edit)</span>
                    </div>

                    <form className='mt-4 text-center' onSubmit={handleSubmit}>
                        <div className="d-flex justify-content-center">

                            <div className="flex">
                                {Array.from({ length: numInputs }).map((_, index) => (
                                    <input
                                        key={index}
                                        ref={(el) => (inputsRef.current[index] = el)}
                                        type="text"
                                        value={otp[index]}
                                        onChange={(e) => handleChange(e.target.value, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        onPaste={handlePaste}
                                        inputMode="numeric"
                                        autoComplete="one-time-code"
                                        maxLength={1}
                                        className="otp-input bg-transparent me-3 text-center ff-balooPaaji2-regular fs-40 primary-text"
                                        style={{ width: "3rem", height: "3rem", margin: "0 0.5rem", textAlign: "center", background: "transparent", fontSize: "2rem", color: "var(--primary-text-color)" }}
                                    />
                                ))}
                            </div>

                        </div>
                        <div className="d-flex justify-content-center" >
                            {/* <button type="submit" className="text-center w-100 border-0 primary-bg rounded-pill ff-poppins-semiBold fs-6 text-white mt-5" >
                                Continue
                            </button> */}
                            <button type="submit" className={(isLoading ? "loading" : "") + " " +
                                ` primary-bg  w-100 border-0 rounded-pill ff-poppins-semiBold fs-20 text-white mt-5 d-flex justify-content-center align-items-center`}>
                                {
                                    isLoading
                                        ?
                                        <span className="loader-style-1"></span>
                                        :
                                        <span>
                                            Continue
                                        </span>
                                }
                            </button>
                        </div>

                        <div className="ff-poppins-medium  fs-14 text-center x mt-3 pt-2">
                            {showResendOTP ?
                                <>
                                    <span  > Didn’t receive OTP ? </span>
                                    <div role="button"   > please check your inbox and spam folder </div>
                                    <span className="primary-text mt-2" onClick={() => resendOTP()} >Resend OTP </span>
                                </>
                                :
                                <span>Resend OTP in 0:<CountdownTimer trigger={triggerTimer} triggerStart={() => setShowResendOTP(true)} /></span>}

                        </div>



                        {/* <button
                            className='submitBtn mt-4 primary-bg text-white ff-poppins-semiBold fs-20 d-flex justify-content-center align-items-center border-0 w-100'
                            type="submit">
                            Submit
                        </button> */}


                    </form>


                </div >


                {modalOpen && (
                    <>
                        <div className="modal-backdrop fade show"></div>

                        <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-dialog-centered modal-sm m-0">
                                <div className="modal-content">
                                    <div className="modal-body ps-4 pe-4 pt-3 pb-3 ">
                                        <div className='text-center ff-poppins-semiBold fs-14'>Enter E-mail</div>
                                        <input type="email" className="form-control rounded-0 border-0   no-spinners w-100 ff-poppins-medium fs-14" name="user_email"
                                            maxLength={45}
                                            value={userEmail}
                                            placeholder="Enter the email id"
                                            onChange={(e) => (setuserEmail(e.target.value))}
                                        />
                                        <div className="d-flex justify-content-between mt-3">
                                            <button type="button" className="loginAddemailModelBtn bg-secondary" onClick={() => setModalOpen(false)}>Cancel</button>
                                            <button
                                                type="button"
                                                className="loginAddemailModelBtn primary-bg"
                                                onClick={handelEditUserMobileNum}
                                                disabled={btnloadingStatus}
                                            >
                                                {btnloadingStatus ? <span className="spinner-border spinner-border-sm" /> : "Done"}

                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div >
        </div>
        </>
    )
};

export default CodeVerification;